/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Nice_Fuzzy_Flamingo_HealInputs */

const fr_nice_fuzzy_flamingo_heal = /** @type {(inputs: Nice_Fuzzy_Flamingo_HealInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modifiez les informations de la catégorie "${i?.title}"`)
};

/**

* @param {Nice_Fuzzy_Flamingo_HealInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const nice_fuzzy_flamingo_heal = /** @type {((inputs: Nice_Fuzzy_Flamingo_HealInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nice_Fuzzy_Flamingo_HealInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_nice_fuzzy_flamingo_heal(inputs)
});